import { useEffect } from "react";
import type { ErrorComponentProps } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";

// Was src/app/global-error.tsx. As the __root route's errorComponent this
// renders in place of RootLayout, so there is no ThemeProvider and no Convex
// client here — keep the UI provider-free and avoid <Link> (the router is up,
// but a crashed root usually means navigation won't help).
//
// Unlike the Next version this does not re-declare <html>/<body> or re-import
// the fonts: index.html owns the shell, and the inline script there has
// already applied the stored theme.
export function RootError({ error, reset }: ErrorComponentProps) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="flex min-h-svh items-center justify-center p-6">
      <div className="w-full max-w-sm text-center">
        <div className="flex flex-col gap-3">
          <h1 className="text-lg font-semibold tracking-tight">
            Something went wrong
          </h1>
          <p className="text-muted-foreground text-sm leading-6">
            Veez HQ hit an unexpected error and couldn&apos;t load. Try again,
            or reload the page. If it keeps happening, let an admin know.
          </p>
          <div className="mt-2 flex items-center justify-center gap-2">
            <Button variant="outline" onClick={() => reset()}>
              Try again
            </Button>
            <Button onClick={() => window.location.reload()}>Reload</Button>
          </div>
        </div>
      </div>
    </div>
  );
}
